<template>
<div>PersonalData
  <el-button type="primary" @click="$router.push('/gocat')">回到GO车惠</el-button>

</div>
</template>

<script>
export default {
  name: "PersonalData",

}
</script>

<style>

</style>
